import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RichText from '../controls/RichText';
import { useForceUpdate } from '../util';
import { TabContextReporter } from '../TabContext';
import NeutralToggle from '../controls/NeutralToggle';
import { FormValidityReporter } from '../FormValidity';
import { contentIsEmpty } from './TaskMultiChoice';
export default function TaskTrueFalse(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Question Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Statement Text:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.question,
    onChange: v => {
      dataProps.question = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.question)
  }, "Statement Text is empty.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Answer:")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(NeutralToggle, {
    optionTrue: "Correct",
    optionFalse: "Incorrect",
    value: dataProps.correct,
    onChange: v => {
      dataProps.correct = v;
      forceUpdate();
      props.onChanged();
    }
  })))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "Feedback"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.correctFeedback,
    onChange: v => {
      dataProps.correctFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.incorrectFeedback,
    onChange: v => {
      dataProps.incorrectFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })))));
}